import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";
import KnowUSoon from "../views/KnowUSoon.vue";
import HowToReserve from "../views/HowToReserve.vue";
import Reserve from "../views/Reserve.vue";
import Service from "../views/Service.vue";
import ReserveCheck from "../views/ReserveCheck.vue";
import Doctor from "../views/Doctor.vue";
import News from "../views/News.vue";
import NewsInfo from "../views/NewsInfo.vue";
import HeartRoad from "../views/HeartRoad.vue";
import ContactUs from "../views/ContactUs.vue";
import WeCare from "../views/WeCare.vue";
import BackStage from "../views/BackStage.vue";
import DocGroup from "../views/DocGroup.vue";
import Banners from "../views/Banners.vue";
import Articles from "../views/Articles.vue";
import NotFound from "../views/NotFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index
  },
  {
    path: "/knowusoon",
    alias: "/KnowUSoon",
    name: "KnowUSoon",
    component: KnowUSoon
  },
  {
    path: "/how-to-reserve",
    alias: "/HowToReserve",
    name: "HowToReserve",
    component: HowToReserve
  },
  {
    path: "/reserve",
    alias: "/Reserve",
    name: "Reserve",
    component: Reserve
  },
  {
    path: "/reserve-check",
    alias: "/ReserveCheck",
    name: "ReserveCheck",
    component: ReserveCheck
  },
  {
    path: "/service",
    alias: "/Service",
    name: "Service",
    component: Service
  },
  {
    path: "/doctor/:uid",
    alias: "/Doctor/:uid",
    name: "Doctor",
    component: Doctor
  },
  {
    path: "/news",
    alias: "/News",
    name: "News",
    component: News
  },
  {
    path: "/news/:uid",
    alias: "/News/:uid",
    name: "NewsInfo",
    component: NewsInfo
  },
  {
    path: "/heart-road",
    alias: "/HeartRoad",
    name: "HeartRoad",
    component: HeartRoad
  },
  {
    path: "/contact-us",
    alias: "/ContactUs",
    name: "ContactUs",
    component: ContactUs
  },
  {
    path: "/we-care",
    alias: "/WeCare",
    name: "WeCare",
    component: WeCare
  },
  {
    path: "/backstage",
    alias: "/BackStage",
    name: "BackStage",
    component: BackStage,
    children: [
      {
        path: "doctors",
        alias: "DocGroup",
        name: "DocGroup",
        component: DocGroup
      },
      {
        path: "banners",
        alias: "Banners",
        name: "Banners",
        component: Banners
      },
      {
        path: "articles",
        alias: "Articles",
        name: "Articles",
        component: Articles
      }
    ]
  },
  { path: "*", name: "NotFound", component: NotFound }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
